/**
 * @generated SignedSource<<503387c2e7d50f2a1db4fed9529414b7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductShipping_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useShippingPriceV2_viewer">;
  readonly " $fragmentType": "ProductShipping_viewer";
};
export type ProductShipping_viewer$key = {
  readonly " $data"?: ProductShipping_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductShipping_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductShipping_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShippingPriceV2_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "1d9d67725ac4862f6563edc2374a6c7f";

export default node;
